import { render, staticRenderFns } from "./A.vue?vue&type=template&id=45c34ccd&scoped=true&"
import script from "./A.vue?vue&type=script&lang=js&"
export * from "./A.vue?vue&type=script&lang=js&"
import style0 from "./A.vue?vue&type=style&index=0&id=45c34ccd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c34ccd",
  null
  
)

export default component.exports